var scope_0 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3670414d18e56fa7a1f55135b4d3faf1.js').default;
var scope_1 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ffb5f58668100b493e04266d40e7da0.js').default;
var scope_2 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7b7f0c195144e1946257a12a04eb53d3.js').default;
var scope_3 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/92f9d2cb135a3f7800271b34af13386c.js').default;
var scope_4 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/af51636b772c8ab86efcc36c3a6e9a5d.js').default;
var scope_5 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b3bcad495a1b0956564d74b913532b02.js').default;
var scope_6 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7e2b9f8193f758a66f25913be92519b.js').default;
var scope_7 = require('/home/drago/Work/RepairSetup/www.feroko.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    